<template>
    <title-cover class="w-50">
        <p class="dv-title">
            <slot></slot>
        </p>
    </title-cover>
</template>

<script>
import TitleCover from "@/components/echarts-part/kpi/sith/cells/TitleCover";
export default {
    name: "KpiTitle",
    components: {TitleCover}
}
</script>

<style scoped>
.dv-title {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
    -webkit-font-smoothing: antialiased;
    font-size: 1.5rem;
    color: #7ec699;
    font-weight: 700;
    margin: auto 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>